export const environment = {
  production: false,
  appVersion: 'v1',
  apiUrl: 'https://portalapi.sapec.md/api',
};
